import { useRef } from '@max/max';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH, ScoreType, TravelServiceType } from '../types/shared';
export var INTENTION_SCENE;
(function (INTENTION_SCENE) {
    INTENTION_SCENE[INTENTION_SCENE["HOTEL_TRAVEL_INTENTION"] = 1] = "HOTEL_TRAVEL_INTENTION";
})(INTENTION_SCENE || (INTENTION_SCENE = {}));
var INTENTION_TAG_ID;
(function (INTENTION_TAG_ID) {
    INTENTION_TAG_ID[INTENTION_TAG_ID["HOTEL_TRAVEL_INTENTION"] = 5] = "HOTEL_TRAVEL_INTENTION";
})(INTENTION_TAG_ID || (INTENTION_TAG_ID = {}));
// ScoreType 到 TravelServiceType 的映射
const SCORE_TYPE_TO_TRAVEL_SERVICE_TYPE_MAP = {
    [ScoreType.HotelScore]: [TravelServiceType.Hotel],
    [ScoreType.TicketScore]: [TravelServiceType.Ticket],
    [ScoreType.VacationScore]: [TravelServiceType.Vacation],
    [ScoreType.TrafficScore]: [TravelServiceType.Flight, TravelServiceType.Train]
};
export const useIntentionData = () => {
    const { request } = useRequest(API_PATH.QUERY_INTENTION);
    const maxIntentionBiz = useRef(ScoreType.HotelScore);
    const ctx = useMonitorEngineContext();
    const queryIntentionInfo = async (params = {}) => {
        try {
            Object.assign(params, {
                scene: INTENTION_SCENE.HOTEL_TRAVEL_INTENTION,
                tagIds: [INTENTION_TAG_ID.HOTEL_TRAVEL_INTENTION]
            });
            const res = await request(params);
            if (res?.uni_status_code) {
                ctx?._raptorReport?.monitorReportBizFailed?.();
                return null;
            }
            if (Array.isArray(res?.tags) && res.tags.length > 0) {
                ctx?._raptorReport?.monitorReportBizSuccess?.();
                const tagInfoMap = res.tags.find(tag => tag?.tagId === INTENTION_TAG_ID.HOTEL_TRAVEL_INTENTION)?.tagInfoMap || {};
                // 找到最大意向度业务线
                let maxBiz = ScoreType.HotelScore;
                let maxScore = 0;
                Object.entries(tagInfoMap).forEach(([scoreType, score]) => {
                    if (typeof score === 'number' && score > maxScore) {
                        maxScore = score;
                        maxBiz = scoreType;
                    }
                });
                maxIntentionBiz.current = maxBiz;
                // 将 ScoreType 转换为 TravelServiceType
                const convertedTagInfoMap = {};
                Object.entries(tagInfoMap).forEach(([scoreType, score]) => {
                    const travelServiceTypes = SCORE_TYPE_TO_TRAVEL_SERVICE_TYPE_MAP[scoreType];
                    if (travelServiceTypes && typeof score === 'number') {
                        travelServiceTypes.forEach(serviceType => {
                            convertedTagInfoMap[serviceType] = score;
                        });
                    }
                });
                return convertedTagInfoMap;
            }
            else {
                ctx?._raptorReport?.monitorReportBizFailed?.();
                return {};
            }
        }
        catch (error) {
            ctx?._raptorReport?.monitorReportBizFailed?.();
            return {};
        }
    };
    return {
        queryIntentionInfo,
        maxIntentionBiz
    };
};
